// import { userActionType } from './user.action.type';

// const INITIAL_STATE = {
//   currentUser: null,
// };

// const userReducer = (state = INITIAL_STATE, action) => {
//   // console.log(action.payload)
//   switch (action.type) {
//     case userActionType.SET_CURRENT_USER:
//       return {
//         ...state,
//         currentUser: action.payload,
//         stockTransferRequests: 0, 
//       };
//     case userActionType.SET_TRANSFER_REQUESTS:
//       return {
//         ...state,
//         stockTransferRequests: action.payload,
//       };
//     default:
//       return state;
//   }
// };

// export default userReducer;


// Redux Toolkit 

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
// import axios from "axios";

const initialState = {
    currentUser: null,
    loading: false,
    error: null
  };

 export  const fetchUser = createAsyncThunk('user/fetchUser', async (_, { getState }) => {
  try {
    const state = getState();
    
    const token = state.user.currentUser.token;
    // const token = localStorage.getItem('token');
    // const user = localStorage.getItem('user');
    // console.log(state.user.loading);
    
    // const token = useSelector(state => state.currentUser.token);
    const id = state.user.currentUser._id;

    // console.log("token",token);
    // console.log("user",user);
    // const parsedUser = user ? JSON.parse(user) : null;
    // console.log(id);
   

    const headers = {
      'Authorization': `Bearer ${token}`, // Attach the token here
      'Content-Type': 'application/json', // Ensure the correct content type is set
    };

    const url = `${process.env.REACT_APP_API_URL}user/${id}`;

    // const response = await fetch('http://localhost:8000/api/v1/user/650016d2ffa58f5efb457aa2');
    const response = await fetch( url,{
      
        method: 'GET',  // Default method is GET, but specify if needed
        headers: headers,  // Add the headers with the token
      }
    );


    const responseJson = await response.json();
    // console.log('data--',responseJson);
    
    return responseJson.data;
  
  } catch (error) {
    console.error('Error fetching data:', error);
    
  }
});

const userSlice = createSlice({
    name : 'user',
    initialState,
    reducers:{

      setCurrentUser: (state, action) => {
        
            state.currentUser = action.payload;
            state.stockTransferRequests= 0

          },
          setTransferRequests: (state, action)=> {
            state.stockTransferRequests = action.payload;
          }
     


    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchUser.pending, (state) => {
          state.loading = true;  
          state.error = null;    
        })
        .addCase(fetchUser.fulfilled, (state, action) => {
          state.loading = false;     
          state.currentUser = action.payload; 
        })
        .addCase(fetchUser.rejected, (state, action) => {
          state.loading = false;      
          state.error = action.error.message;
        });
    }
})

export const { setCurrentUser, setTransferRequests } = userSlice.actions;

export default userSlice.reducer;
